import { BACKEND_URL } from '@/core/config';
import { server } from '../core/server/axios';
import { AgreementModel } from '@/interface';

export interface AddDepartmentVariables {
    name: string,
    code: string,
    address: string,
    bin: string,
    adviser: string
    accountant: string
    branch: string
    city: string
    street: string
}

export interface UpdateDepartmentVariables {
    id: number,
    name?: string,
    code?: string,
    address?: string,
    bin?: string,
    adviser?: string,
    isActive?: 0 | 1
    accountant: string
    branch: string
    city: string
    street: string
}

export class DepartmentCotroller {
    async addDepartment(request: AddDepartmentVariables): Promise<any> {
        return await server.post('/Department/newDepartment', {
            ...request,
            office: 0,
            isActive: 1,
            region: "",
            lon: "",
            lat: "",
            roles: "",
            openTime: "",
            closeTime: "",
            district: "",
            officialOpenTime: "",
        }, {
            baseURL: BACKEND_URL
        });
    }

    async getDepartments(): Promise<any> {
        return await server.get('/Department/getDepartmentList', {
            baseURL: BACKEND_URL
        });
    }

    async getDepartmentsLanding(): Promise<any> {
        return await server.get(`/Department/getDepsLandingInfo?cache_bust=${Date.now()}`, {
            baseURL: BACKEND_URL
        });
    }

    async updateDepartment(request: UpdateDepartmentVariables): Promise<any> {
        return await server.post('Department/updateDepartment', request, {
            baseURL: BACKEND_URL
        });
    }

    async getAgreements(): Promise<{ id: number, agreements: AgreementModel[] }[]> {
        return await server.get(`/Department/agreements`, {
            baseURL: BACKEND_URL
        });
    }
}